import { useState, useEffect, useRef } from 'react';
import FeaturedNavSection from './FeaturedNavSec';
import { useLazyQuery } from '@apollo/client';
import { CITIES_FILTER, CITY_FILTER_INTERFACE } from '../../api/cityfilter';
import FEATUREDEXPERIENCES, {
  FEATURED_EXPERIENCES_INTERFACE
} from '../../api/featuredexperiences';
import { HOMEPAGEINTERFACE } from '../../api/homePage';
import TourCard from '../Tour/tourCard';
import { PAGE_OPTIONS } from '../Trust/Trustbar';
import { useRouter } from 'next/router';

const arr = [
  {
    filterClass: 'allThings',
    filterName: 'All Things To Do'
  },
  {
    filterClass: 'dayTours',
    filterName: 'Day Tours'
  },
  {
    filterClass: 'privateTours',
    filterName: 'Private Tours'
  }
];

interface FeaturedExperiencesProps {
  featuredExp: {
    [key: string]: any;
  };
  citydropdown: any;
  selectedCity?: string | undefined;
  privateTourPage?: boolean;
}
const FeaturedExperiences = ({
  featuredExp,
  citydropdown,
  selectedCity,
  privateTourPage
}: FeaturedExperiencesProps) => {
  const [activeNav, setActiveNav] = useState(
    privateTourPage ? 'privateTours' : 'allThings'
  );

  const fexp_Ref = useRef<HTMLDivElement>(null);
  const [city, setCity] = useState<any>(selectedCity || 'All Cities');
  const [cityToggle, setCityToggle] = useState<boolean>(false);
  const [navArray, setNavArray] = useState<any>(arr);
  const [featuredExperienceData, setFeaturedExperienceData] = useState<
    FEATURED_EXPERIENCES_INTERFACE | HOMEPAGEINTERFACE | any
  >([]);
  const router = useRouter();
  const [showAll, setShowAll] = useState(
    router.pathname === '/[slug]' ? true : false
  );
  //FETCHING QUERIES
  //fetch day & multiday
  const [fetchTourType, { data: tourData, loading: tourFilterLoading, error }] =
    useLazyQuery<FEATURED_EXPERIENCES_INTERFACE>(FEATUREDEXPERIENCES);

  //fetch by city
  const [
    cityFilteredTours,
    {
      data: { cities: [filteredCity] = [] } = {} as CITY_FILTER_INTERFACE,
      loading: cityFilterLoading,
      error: cityFitlerError
    }
  ] = useLazyQuery<CITY_FILTER_INTERFACE>(CITIES_FILTER);

  //USEFFECTS()

  //useffect-1
  useEffect(() => {
    filteredCity && setFeaturedExperienceData(filteredCity);
  }, [filteredCity]);

  //useffect-2
  useEffect(() => {
    if (
      !privateTourPage &&
      activeNav !== 'allThings' &&
      city === 'All Cities'
    ) {
      try {
        fetchTourType({
          variables: {
            dayTours: true,

            multiday: true,
            airportTransfers: true
          }
        });
      } catch (error) {}
    }
  }, [activeNav]);

  //useffect-3
  useEffect(() => {
    setFeaturedExperienceData(tourData?.homePage);
  }, [tourData]);

  //useffect-4
  useEffect(() => {
    const finalNavArray: Array<Record<string, any>> = [];
    let flag = true;
    arr.forEach(item => {
      finalNavArray.push(item);
    });

    if (city === 'All Cities') {
      setNavArray(arr);
      setFeaturedExperienceData(tourData?.homePage);
    } else {
      setNavArray(finalNavArray);
      finalNavArray?.forEach(item => {
        if (item?.filterClass == activeNav) {
          flag = false;
        }
      });
      if (flag) {
        setActiveNav('allThings');
      }
    }
  }, [city, activeNav]);

  //usefffect-5
  useEffect(() => {
    if (!selectedCity) {
      cityFilteredTours({
        variables: {
          filter: {
            name: city
          }
        }
      });
    }
  }, [city, cityFilteredTours]);

  //FUNCTIONS
  const Drop_Down_options = () => {
    const options: Array<Record<string, unknown>> = [];
    const filteredCities = citydropdown ? citydropdown : [];
    filteredCities?.forEach((obj: Record<string, unknown>) => {
      options.push({ value: [obj?.name], label: [obj?.name] });
    });

    return options.sort((a: any, b: any) => {
      const x = a.label[0].toUpperCase();
      const y = b.label[0].toUpperCase();
      return x === y ? 0 : x > y ? 1 : -1;
    });
  };
  const sortedCities = Drop_Down_options();
  const showActiveNav = () => {
    if (activeNav === 'allThings') return 'All Things To Do';
    else if (activeNav === 'dayTours') return 'Day Tours';
    else if (activeNav === 'multiday') return 'Multi Day Tours';
    else if (activeNav === 'privateTours') return 'Private Tours';
  };
  const dispLoading = () => {
    if (city !== 'All Cities' && cityFilterLoading) {
      return (
        <div
          role="status"
          className="flex justify-center items-center h-[50px] "
        >
          <svg
            aria-hidden="true"
            className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-gray-700"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        </div>
      );
    }
    if (tourFilterLoading) {
      return (
        <div
          role="status"
          className="flex justify-center items-center h-[50px] "
        >
          <svg
            aria-hidden="true"
            className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-gray-700"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        </div>
      );
    }
  };

  const displayProduct = () => {
    const filteredProduct = featuredExperienceData
      ? featuredExperienceData[activeNav]
      : featuredExp
      ? featuredExp[activeNav]
      : [];
    if (!filteredProduct || filteredProduct?.length === 0) {
      return (
        <h3>{`${tourFilterLoading ? '' : `Tours coming to ${city} soon`}`}</h3>
      );
    }

    // prevent null & duplicate items
    const uniquefilteredProduct = Array.isArray(filteredProduct)
      ? filteredProduct
          ?.filter((item: Record<string, any>) => item?.product != null)
          ?.reduce((acc: Record<string, any>[], curr: Record<string, any>) => {
            const isdup = acc?.find(
              (item: any) => item?.product?.id === curr?.product?.id
            );
            return !isdup ? [...acc, curr] : acc;
          }, [])
      : [];

    return uniquefilteredProduct
      ?.slice(0, showAll ? uniquefilteredProduct?.length : 6)
      ?.map((product: Record<string, any>, index: number) => {
        return (
          <TourCard
            key={index}
            product={product?.product}
            productType={
              Number(product?.duration) > 24
                ? PAGE_OPTIONS.MULTIDAY_TOUR_PAGE
                : PAGE_OPTIONS.DAY_TOUR_PAGED
            }
          />
        );
      });
  };
  const showProduct = () => {
    let selectedNav = '';
    const selectNum = featuredExperienceData
      ? //@ts-ignore
        featuredExperienceData[activeNav]?.length
      : featuredExp[activeNav]?.length;
    if (activeNav === 'allThings') {
      selectedNav = 'All Things To Do';
    }
    if (activeNav === 'dayTours') {
      selectedNav = 'All Day Tours ';
    }
    if (activeNav === 'multiday') {
      selectedNav = 'All Multi Day Tours';
    }
    if (activeNav === 'privateTours') {
      selectedNav = 'Private Tours';
    }

    if (!showAll && !tourFilterLoading && !cityFilterLoading) {
      return (
        <div className=" w-[90%] lg:w-[80%] 3xl:w-[80%]  max-w-[1750px] mx-auto flex justify-end pt-3 pb-10 border-b border-slate-400">
          {selectNum > 6 && (
            <div
              onClick={() => setShowAll(true)}
              className="cursor-pointer flex items-center"
            >
              {/* <h2 className="text-sky-500 text-3xl font-[600]">{`See ${selectedNav} (${selectNum})`}</h2> */}
              {router.pathname !== '/[slug]' && (
                <h2 className="text-[20px] text-[#6D6D6D] font-[400] cursor-pointer">
                  See More
                </h2>
              )}
            </div>
          )}
        </div>
      );
    }
    if (showAll && !tourFilterLoading && !cityFilterLoading && selectNum > 6) {
      return (
        <div className=" w-[75%] lg:w-[80%] 3xl:w-[70%]  max-w-[1750px] mx-auto flex justify-end mt-5 ">
          <div
            onClick={() => {
              setShowAll(false);
              fexp_Ref.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }}
            className="cursor-pointer"
          >
            {router.pathname !== '/[slug]' && (
              <h2 className=" text-base text-[#6D6D6D] font-[400] cursor-pointer">
                Show Less
              </h2>
            )}
          </div>
        </div>
      );
    }
  };

  return (
    <section id="feature_experiences" ref={fexp_Ref}>
      <header
        id="feature_experience_header"
        className="lg:flex items-center mt-3 lg:mt-10 w-[90%] lg:w-[85%] 3xl:w-[80%]  max-w-[1750px] mx-auto"
      >
        <FeaturedNavSection
          currNav={activeNav}
          setActiveNav={setActiveNav}
          navData={navArray}
        />
        <div
          id="featured_dropdown"
          className=" max-w-[70%] lg:max-w-[45%]  ml-auto mr-[8%] xsm:mr-[5%] sm:mr-[8%] md:mr-[5%] lg:mr-0  lg:flex-none  "
        >
          <div id="city_dropDown" className="flex justify-end items-center ">
            <p className="flex-none pr-2 xl:pr-3 text-justify text-[12px]  sm:text-[16px]  lg:text-[20px] font-[400] text-[#6D6D6D]">
              Search city:
            </p>
            <div
              id="dropdown"
              onMouseLeave={() => {
                if (cityToggle) return setCityToggle(!cityToggle);
              }}
              className="relative "
            >
              <button
                disabled={selectedCity ? true : false}
                onClick={() => setCityToggle(!cityToggle)}
                className={
                  cityToggle
                    ? `flex justify-between items-center ${
                        selectedCity ? 'opacity-60' : 'opacity-100'
                      } border-[1px] border-[#F15C5A] cursor-pointer rounded-[8px] sm:rounded-[10px] w-[100%] px-1 xsm:px-2  sm:px-5 lg:px-2 2xl:px-3 py-1  text-[12px] sm:text-[14px] md:text-[16.92px] text-[#333333] font-[400] min-w-[150px]`
                    : `flex justify-between items-center  ${
                        selectedCity ? 'opacity-60' : 'opacity-100'
                      } border-[1px] border-[#4F4F4F] cursor-pointer rounded-[8px] sm:rounded-[10px] w-[100%] px-1 xsm:px-2  sm:px-5 lg:px-2 2xl:px-3 py-1 text-[12px] sm:text-[14px] md:text-[16.92px] text-[#333333] font-[400] min-w-[150px]`
                }
              >
                {selectedCity ? selectedCity : city}
                <span className={`${cityToggle ? 'rotate-180' : 'rotate-0'}`}>
                  {/* <DropdownIcon /> */}
                </span>
              </button>
              {cityToggle && (
                <div
                  id="dropdown_list"
                  className={` border-1 border-slate-500 absolute right-0 z-50 w-[100%] h-[400px] overflow-y-scroll `}
                >
                  <div
                    className="px-3 py-1 border-[1px] border-slate-3
                00 hover:bg-slate-300 cursor-pointer bg-white"
                    onClick={() => setCity('All Cities')}
                  >
                    All Cities
                  </div>
                  {sortedCities &&
                    sortedCities?.map((opt: Record<string, any>, index) => {
                      return (
                        <div
                          className="border-[1px] border-slate-3
                00 px-3 py-1 bg-white cursor-pointer hover:bg-slate-300 z-[5000] "
                          key={opt?.label}
                          onClick={() => {
                            setCity(opt.label[0]);
                            setCityToggle(false);
                          }}
                        >
                          {opt?.label}
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      <div
        id="feature_experiences_cards"
        className=" mt-4 lg:mt-6 w-[90%] lg:w-[85%] 3xl:w-[80%] max-w-[1750px] mx-auto"
      >
        {cityFilterLoading && dispLoading()}
        {tourFilterLoading && dispLoading()}
        <div className="grid  grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-6">
          {displayProduct()}
        </div>
      </div>
      {showProduct()}
    </section>
  );
};

export default FeaturedExperiences;
